define('models/AddressAutocompleteModel',[
    'underscore','jquery','backbone',
    'app',
    'router',
    'ObjectModel',
    'ApiRequest',
    'PlaceModel',
    'models/AddressModel',
    'models/EstimatedTimeModel',
    'string'
],function (
    _,$,Backbone,
    app,
    router,
    ObjectModel,
    ApiRequest,
    PlaceModel,
    AddressModel,
    EstimatedTimeModel,
    S
) {
    //
    // Model Address Autocomplete
    //

    var _GOOGLE_ADDRESS_SEPARATOR_,
        // strings const
        PLACE_ID = 'place_id',
        ID_ADDRESS = 'id_address',
        IS_LOCALITY_MATCHING = 'isLocalityMatching',
        iconTemplate = _.template('<i class="icon-<%= i %>"></i> ');

    function dataSep(){
        return _GOOGLE_ADDRESS_SEPARATOR_ = _GOOGLE_ADDRESS_SEPARATOR_ || app.c('_GOOGLE_ADDRESS_SEPARATOR_',',');
    }

    var AutocompleteModelPrototype = {
        name:'AddressAutocompleteModel',
        defaults:{
            fetching:false,
            isLocalityMatching:false,
            status:'INIT',
            source:1,
            ignore_geo_validation:0,
        },
        initialize:function(options){
            var model = this;
            // ObjectModel constructor heritage
            ObjectModel.prototype.initialize.apply(model,options);
            //
            model.on('add',model.setup,model);
        },
        setup:function(){
            var model = this,
                place = model.getPlace(),
                action = model.getAction();
            model.off('add',model.setup);
            model.listenTo(place,'sync',model.onPlaceSync);
             if(action === 'edit' || action === 'invoice' || model.isException()){
                // si on est en mode édition / mon compte
                // ou sur un bouton d'ajout
                // on ne fait rien.
            }else if(model.usePlaceFetch() === false){
                // no fetch mode
            }else if(model.isValid()){
                // si on est en mode recherche d'adresse de livraison / boutique
                //if(model.isStore()){
                //    place.fetch();
                //}
                model.set(IS_LOCALITY_MATCHING,true);
            }else if(place && place.isLocalityMatching() && !place.isSync()){
                model.set(IS_LOCALITY_MATCHING,true);
                model.set('fetching',true);
                place.fetch();
            }else{
                model.set(IS_LOCALITY_MATCHING,false);
            }
        },
        //
        usePlaceFetch:function(){
            return this.get('usePlaceFetch');
        },
        // éxecuté au moment ou le modèle est attaché à une vue
        attachToView:function(){
            var model = this;
            if(model.displayDelay()){
                // si on a juste besoin des informations
                var delay = model.getDelay();
                if(_.isUndefined(delay) && model.getEstimatedTimeOptions()){
                    model.fetchEstimatedTimeOnly();
                }
            }
        },
        isLocalityMatching:function(){
            return this.get(IS_LOCALITY_MATCHING);
        },
        isNew:function(){
            return this.get(ID_ADDRESS) == 'new';
        },
        isValid:function(){
            //
            var model = this,
                action = model.getAction();
            // si on est sur une édition d'adresse, donc sans forcément de notion de livraison
            if(action === 'edit' || action === 'invoice' || model.isException()) return true;
            //
            var postcode = model.getPostcode(),
                hasPostcode = !_.isUndefined(postcode),
                hasDistrict = true,
                store = model.getStore();
            if(store){
                // si une boutique est associé, c'est valide
                return true;
            }
            if(hasPostcode){
                // si il y a un postcode
                var districts = postcode.getDistricts();
                if(districts && districts.length>0){
                    hasDistrict = !_.isUndefined(model.getDistrict());
                }
            }
            if(hasPostcode && hasDistrict){
                return !_.isUndefined(model.getStore());
            }
            return false;
        },
        isFetching:function(){
            return this.get('fetching');
        },
        isStoreOpened:function(){
            var model = this,
                isStoreOpened = model.get('isStoreOpened');
            if(_.isUndefined(isStoreOpened)){
                isStoreOpened = false;
            }else{
                return isStoreOpened;
            }
            var store = model.getStore();
            if(store){
                var availableDatetime = store.findAvailableDatetime(model.isVAE());
                isStoreOpened = availableDatetime.now == 1;
            }
            model.set('isStoreOpened',isStoreOpened);
            return isStoreOpened;
        },
        fetchEstimatedTimeOnly:function(){
            var model = this,
                estimatedTimeModel = EstimatedTimeModel.getModel(model.getEstimatedTimeOptions()),
                delay = estimatedTimeModel.getDelayMinMax(model.isVAE());
            if(delay != 'loading'){
                model.onEstimatedTimeChange(estimatedTimeModel);
            }else{
                model.listenTo(estimatedTimeModel,'sync',model.onEstimatedTimeChange);
               estimatedTimeModel.fetch();
            }
        },
        getEstimatedTimeOptions:function(){
            var model = this,
                store = model.getStore();
            if(!store) return false;
            return {
                id_store:store.id,
                id_postcode:model.isStore()?
                    store.getPostcode().id : // VAE
                    model.getPostcode().id // VAD
            }
        },
        onEstimatedTimeChange:function(estimatedTimeModel){
            var model = this;
            model.setDelayFromModel(estimatedTimeModel);
            model.trigger('sync',model);
        },
        onPlaceSync:function(placeModel){
            var model = this,
                postcode = placeModel.getPostcode();
            model.set('fetching',false);
            if(postcode){
                model.set({
                    id_postcode:postcode.id,
                })
            };

            model.set('types',placeModel.getTypes());
            model.setDelayFromModel(placeModel);
            model.trigger('sync',model);
        },
        setDelayFromModel:function(model){
            var delays = model.pick('delay_min_vad','delay_max_vad','delay_min_vae','delay_max_vae');
            this.set(delays);
        },
        getStore:function(){

            var model = this,
                store = app.getStore(model.get('id_store'));
            if(store) return store;
            if(model.isException()) return;

            var postcode = model.getPostcode(),
                district = model.getDistrict(),
                place = model.getPlace(),
                options = {};

            if(postcode){
                options.id_postcode = postcode.id;
                if(district){
                    options.id_district = district.id_district;
                } else if (postcode.hasDistricts()) {
                    return;
                }
                // TODO reference à app.getCart()
                var stores = app.getStores().findByPostcode(options,app.getCart().getDatetime());
                if(stores.length == 1){
                    store = stores[0];
                }else{
                    district = place.tryDistrict(postcode);
                    if(district){
                        options.id_district = district.id_district;
                        stores = app.getStores().findByPostcode(options);
                        if(stores.length == 1){
                            store = stores[0];
                        }
                    }else{

                        //store = stores[0];
                        if(stores.length>0){
                            app.error('Chevauchement de zones',options);
                        }
                    }

                }
            }else if(place){
            }
            else {
            }
            if(store){
                this.set('id_store',store.id);
            }

            return store;
        },
        getPlace:function(){
            var id = this.get(PLACE_ID);
            if(id) return PlaceModel.getPlace(id,this);
            var customerAddress = this.getCustomerAddress();
            if(customerAddress) return customerAddress.getPlace();
        },
        getPostalCode:function(){
            //
            // --- attention ---
            // le "postal_code" est différent du "postcode"
            // le postcode est lié à une donnée sushishop (id_postcode)
            // le postal_code est une donnée brute postale
            //
            var model = this,
                place = model.getPlace(),
                postal_code = model.get('postal_code') || '';
            if(place){
                postal_code = place.get('postal_code') || postal_code;
            }
            return postal_code;
        },
        getPostcode:function(){
            var model = this,
                p = model.getPlace(),
                customerAddress,
                overridePostcodeId = model.get('id_postcode'); // permet de ne pas utiliser PlaceModel
            if(overridePostcodeId) return app.getPostcode(overridePostcodeId);
            // si on a une adresse utilisateur, on utilise son code postal
            customerAddress = model.getCustomerAddress();
            if(customerAddress){
                return customerAddress.getPostcodeModel();
            }
            // si on a une Place, on utilise son code postal
            if(p) return p.getPostcode();
        },
        getDistrict:function(){
            var model = this,
                overrideDistrictId = model.get('id_district'), // permet de ne pas utiliser PlaceModel
                p = model.getPlace();

            if(overrideDistrictId) return model.getPostcode().getDistrict(overrideDistrictId);

            var customerAddress = model.getCustomerAddress();
            if (customerAddress) return customerAddress.getDistrict();

            if(p) return p.getDistrict();

        },
        getDistrictId:function(){
            var d = this.getDistrict();
            if(d) return d.id_district;
        },
        getLatitude:function(){
            var model = this, lat = 0,
                place = model.getPlace(),
                customerAddress = model.getCustomerAddress();
            if(customerAddress){
                lat = customerAddress.getLatitude();
            }
            if(!lat && place){
                lat = place.getLat();
            }
            return lat || 0;
        },
        getLongitude:function(){
            var model = this, lng = 0,
                place = model.getPlace(),
                customerAddress = model.getCustomerAddress();
            if(customerAddress){
                lng = customerAddress.getLongitude();
            }
            if(!lng && place){
                lng = place.getLng();
            }
            return lng || 0;
        },
        ignoreGeoValidation:function(){
            var model = this,
                latitude = model.getLatitude(),
                longitude = model.getLongitude(),
                zero_lat_lng = !latitude && !longitude
            ;
            return zero_lat_lng ? 1 : model.get('ignore_geo_validation') ;
        },
        getLocality:function(){
            return this.getPlace().getLocality();
        },
        getDescription:function(){
          return this.getLabel();
        },
        getLabel:function(wrapSpan){
            //
            //
            var model = this,
                label,p,d,
                address = model.getCustomerAddress();
            if(model.isException()){
                // sert à afficher le plus pour l'exception ajouter une adresse
                label = model.get('description');
                if(wrapSpan){
                    label = iconTemplate({i:'plus'})+label;
                }
            }else if(model.isStore()){
                label = model.getStore().getName();
            }else{
                p = model.getPlace();
                if(p){
                    d = p.getDescription();
                }
                if(!d){
                    if(address){
                        d = address.formatAutocompleteStreetAddress(true)
                    }else{
                        d = model.get('description');
                    }
                    if(!d){
                        d = 'données d’adresse manquante !'
                    }
                }
                label = d;
            }
            if(wrapSpan){
                _GOOGLE_ADDRESS_SEPARATOR_ = dataSep();
                var wrapStart = '<span data-sep="'+_GOOGLE_ADDRESS_SEPARATOR_+'">',
                    wrapStartDark = '<span data-sep="'+_GOOGLE_ADDRESS_SEPARATOR_+'" class="dark">',
                    wrapEnd = '</span>',
                    split = label.split(_GOOGLE_ADDRESS_SEPARATOR_);
                label = split.map(function(word,index){
                    return ((index>split.length-2)?wrapStartDark:wrapStart)+word+wrapEnd;
                }).join('');
            }
            return label;
        },
        formatAlias:function(ignoreEmpty){
            var address = this.getCustomerAddress(),
                icon = address.getIcon();
            return iconTemplate({i:icon}) + address.formatAliasLabel(ignoreEmpty);
        },
        aliasLength:function(){
            var address = this.getCustomerAddress();
            return !!address ? Math.min(1,address.getAlias().length) : 0;
        },
        dataSep:function(){
            return dataSep();
        },
        formatCustomerStreetAddress:function(){
            return this.getCustomerAddress().formatAutocompleteStreetAddress(true);
        },
        getDelay:function(){
            var model = this,
                vae = model.isStore()?'vae':'vad',
                max = parseInt(model.get('delay_max_'+vae)),
                min = parseInt(model.get('delay_min_'+vae));
            if(max > 0 && min > 0) return {
                max : max,
                min : min
            }
        },
        getResultClasses:function(){
            var model = this,
                isCustomerAddress = model.isCustomerAddress(),
                classes = [];
            classes.push((isCustomerAddress ? 'is':'not' )+'-customer');
            return classes.join(' ');
        },
        isCustomerAddress:function(){
            return !_.isUndefined(this.getCustomerAddress());
        },
        getCustomerAddress:function(){
            var id = this.get(ID_ADDRESS);
            if(id != 'new' && id){
                return app.getAddress(id);
            }
        },
        getPlaceFromDescription:function(callback){
            try{
                var model = this,
                    customerAddress = model.getCustomerAddress(),
                    geocoder = new google.maps.Geocoder()
                    ;
                geocoder.geocode({address:customerAddress.getDescription()},function(results,status){
                    var success = false;
                    if(status == 'OK'){
                        var bestResult = results[0];
                        if(bestResult && bestResult.types[0] == 'street_address'){
                            // si le résultat est bien de type stree_address
                            var place_id = bestResult[PLACE_ID],
                                place = PlaceModel.getPlace(place_id,_(bestResult));
                            model.set(PLACE_ID,place_id);
                            customerAddress.set(PLACE_ID,place_id);
                            customerAddress.save();
                            success = true;
                            //
                        }
                    }
                    callback(success);
                });
            }catch(err){
                callback();
            }
        },
        isVAE:function(){ return this.isStore()}, // alias

        // on utilise le place_id pour stocker l'action
        isException:function(){
            return /^exception_(.+)$/.test(this.get(ID_ADDRESS));
        },
        getException:function(){
            return this.get(ID_ADDRESS);
        },
        // est un résultat "Boutique"
        isStore:function(){
            return this.getType() == 'store';
        },
        // est un résultat "Adresse de livraison"
        isAddress:function(){
            return this.getType() == 'address';
        },
        // attention, ne pas confondre type et types
        // type -> store | address
        getType:function(){
            return this.get('type');
        },
        //
        isRoute:function(){
            // les routes sont des adresses sans numéro de rue
            // renvoie un boolean
            return _(this.getTypes()).contains('route');
        },
        isStreetAddress:function(){
            return _(this.getTypes()).contains('street_address');
        },
        isLoadingDelay:function(){
            return _.isUndefined(this.getDelay());
        },
        displayDelay:function(){
            return this.get('displayDelay') && (this.isLocalityMatching() || this.isStore());
        },
        getAction:function(){
            // l‘action est défini par l'autocomplete collection : cart|edit
            return this.get('action');
        },
        formatDelay:function(){
            var delays = this.getDelay();
            return (this.isLoadingDelay() || !this.displayDelay()) ? '': app.t('entre %s & %s min', 'AddressAutocomplete',[delays.min, delays.max]);
        },
        formatStoreOpening:function(){
            var store = this.getStore(),
                label = '';
             //TODO afficher la date de la prochaine ouvertue
            if(store){
                label = store.getNextOpening('time');
            }
            return label;
        },
        //
        isEqualTo:function(compareModel,compareType){
            // compare deux AutocompleteModel pour voir si ils sont proches
            var baseModel = this,
                baseType = baseModel.getType();
            if(baseType == compareType){
                if(baseType=='store'){
                    // si on est sur une ligne
                    if(baseModel.getStore().id == compareModel.getStore().id){
                        return true;
                    }
                }else if(baseType=='address'){
                    if(baseModel.getPlace().id == compareModel.getPlace().id){
                        return true;
                    }
                }
            }
            return false;
        },
        //
        // attention, ne pas confondre type et types
        // types -> tableau défini par Google Place
        // sauf si il n'y a pas de place, ça sous-entend que c'est une boutique
        getTypes:function(){
            var place = this.getPlace(),
                types = place ? place.getTypes() : ['store'];
            //
            // TODO warning pour gérer la rétrocompatibilité avec les adresses V2, sans id_place ?
            //
            return types;
        },
        //
        getTemporaryAddress:function(){
            // instancie une adresse temporaire
            // hors du carnet d'adresse
            // afin d'avoir des fonctions de formatage dans la partie checkout address
            var model = this,
                place = model.getPlace(),
                address = model.getCustomerAddress();
            if(!address && place){
                address = AddressModel.createAddressFromPlace(place);
                address.set('source',1) // Address::SOURCE_GOOGLE_AUTOCOMPLETE
            }
            return address;
        },
        //
        actionEditAddress:function(options){
            var model = this,
                address = app.getAddress(model.get('id_address')),
                customer_primary = options.customer_primary===true || app.hasNotCustomerPrimaryAddress(),
                attach_to_cart = options.attach_to_cart==1?1:0,
                data = options.data;
//
            !data && address && (data = address.getData());
            function ErrorAddress(err){
                model.trigger('error',err);
            }
            //
            function SyncAddress(){

                var existingAddress = app.getAddress(address.id,true); // on recherche une adresse avec le même Id
                if(existingAddress){ // si elle existe déjà
                    existingAddress.set(address.attributes); // on la met à jour
                }else{
                    app.getAddresses().add(address); // sinon on l'ajoute à la liste des adresses
                }

                if(customer_primary){
                    app.getCustomer().set(ID_ADDRESS+'_primary',address.id);
                }
                if(attach_to_cart==1){
                    app.getCart().set(ID_ADDRESS+'_delivery',address.id);
                }
                model.trigger('afterSync',address);
            }
            //
            if(!address){
                // nouvelle adresse
                address = app.getAddresses().createAddressFromPlace(model.getPlace(),attach_to_cart,data,customer_primary);
                if(address) {
                    address.once('error',ErrorAddress);
                    if(address.id == 'empty_address'){
                        SyncAddress();
                    }else{
                        address.once('sync', SyncAddress);
                    }
                }
            }else{
                // address existante ou fallback

                address.once('sync',SyncAddress);
                address.once('error',ErrorAddress);
                address.save({
                    attach_to_cart:attach_to_cart,
                    customer_primary:customer_primary?1:0,
                    data:data
                })
            }
            return address;
        },
        // affecte au panier le champs selectionné
        actionDeliveryOption:function(cart){
            var model = this,
                address = model.getCustomerAddress(),
                options = model.isVAE() ? model.formatStoreOptions() : model.formatAddressOptions(),
                deliveryOptions = model.toJSON();


            //
            //if(!model.isVAE() && model.isRoute()){
            //    return app.confirm({
            //        title:t('Attention','UI'),
            //        subtitle:
            //        t('vous avez peut-être oublié le numéro de rue','AddressAutocomplete')+'. '+
            //        t('Voulez-vous ','AddressAutocomplete')
            //    });
            //}
            //
            if(address){
                deliveryOptions = _(deliveryOptions).defaults(address.toJSON());
            }
            cart.setDeliveryOptions(options,deliveryOptions);
        },
        //
        validate:function(){
            var model = this, status = 'OK', action = model.getAction(), place, isCustomerAddress;
            if(model.isException()){
                status = model.getException().toUpperCase();
            }else if (action == 'cart') {

                var store = model.getStore(), isVAE = model.isVAE();
                if (!store) {
                    status = 'NO_STORE';
                }
                if (!isVAE) {
                    place = model.getPlace(),
                    isCustomerAddress  = model.isCustomerAddress();
                    if ((_.isUndefined(place)) || (/^fallback_place_/.test(place.id)) || isCustomerAddress) {
                        // STATUS OK
                        if (!store) {
                            status = 'INVALID_ADDRESS';

                            // lié au cas exceptionnel SSRST-266
                            // tentative de redressement d'id_postcode si il est remis à zero
                            var postcode = model.getPostcode(),
                                customerAddress = model.getCustomerAddress();
                            // si le code postal a des quartiers et que l'adresse n'en a pas, on va essayé de l'affecter.
                            if(isCustomerAddress && place && postcode.hasDistricts() && !customerAddress.get('id_district')){
                                status = 'INVALID_ADDRESS_DISTRICT';
                            }
                        }
                    } else if (!place.isSync()) {
                        status = 'NO_FETCHED_PLACE';
                    }else if(app.c('_ADDRESS_REQUIRE_STREET_NUMBER_') == 1 && model.isRoute()){
                        status = 'NO_STREET_NUMBER';
                    }else if(store){
                        var addresses = app.getAddresses();
                        // on vérifie que la ville appartient au carnet d'adresse client.
                        if(addresses.size()>0 && !addresses.containsLocality(place.getLocality()) && !model.get('LOCALITY_USER_CHECKED')){
                            status = 'UNKNOWN_LOCALITY';
                        }
                    }
                }
            }else if(action === 'edit' || action === 'invoice'){
                // customer address edit
                place = model.getPlace();
                if(place){
                    if(!place.isSync()){
                        status = 'NO_FETCHED_PLACE';
                    }
                }
            }
            if(place && place.get('no_alternative')){
                status = 'INVALID_ADDRESS';
            }
            model.set('status',status);
            return status
        },
        // formatage des options de livraison envoyé via l’API
        // options VAE (click & collect)
        formatStoreOptions:function(id_store){
            var options = this.pick('id_postcode');
            options.id_store = this.getStore().id;
            options.vae = 1;
            return options;
        },

        // options VAD (click & delivery)
        formatAddressOptions:function(){
            var model = this,
                ignoreGeoValidation = model.ignoreGeoValidation(),
                options = {
                    postcode:model.getPostalCode(),
                    ignore_geo_validation: ignoreGeoValidation,
                    place_id:model.get(PLACE_ID),
                    id_address_delivery:model.get(ID_ADDRESS),
                    vae:0
                };
            if(ignoreGeoValidation){
                var postcode = model.getPostcode(),
                    district = model.getDistrict();
                if(postcode) options['id_postcode'] = postcode.id;
                if(district) options['id_district'] = district.id_district;
            }else{
                var latitude = model.getLatitude(),
                    longitude = model.getLongitude();
                options['latitude'] = latitude;
                options['longitude'] = longitude;
            }
            //
            return options;
        },

        subscribePostcode:function(emailAddress){
            var model = this,
                postalCode = model.getPostalCode(),
                place = model.getPlace(),
                datas = {description:model.getDescription()};
            if(emailAddress){
                datas.email=emailAddress;
            }
            if(place){
                datas.description = place.get('description')
                datas.place_id = place.get('place_id')
                datas.latitude = place.get('lat')
                datas.longitude = place.get('lng')
            }
            return ApiRequest('PostcodeSubscribe',datas,{postcode:postalCode});
        },
    };

    var GooglePlacesAPIAutocompleteModel = ObjectModel
        .extend(AutocompleteModelPrototype);

    return GooglePlacesAPIAutocompleteModel;
});
